import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const SortIcon = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 24.27 11.625' className={className}>
    <g id='Group_2284' data-name='Group 2284' transform='translate(-108.365 -182.188)' opacity='0.6'>
      <path
        id='Path_13294'
        data-name='Path 13294'
        d='M6.444.082A.647.647,0,0,0,7.117-.6V-8.079L7.068-9.387,8.637-7.636l1.381,1.369a.678.678,0,0,0,.479.2.637.637,0,0,0,.648-.66.668.668,0,0,0-.212-.485l-3.992-4a.688.688,0,0,0-.5-.212.692.692,0,0,0-.5.212l-3.986,4a.668.668,0,0,0-.212.485.632.632,0,0,0,.642.66.681.681,0,0,0,.485-.2L4.245-7.636,5.82-9.393,5.766-8.079V-.6A.649.649,0,0,0,6.444.082Z'
        transform='translate(106.622 193.731)'
        fill='#808f94'
      />
      <path
        id='Path_13295'
        data-name='Path 13295'
        d='M4.7,11.5a.647.647,0,0,0,.672-.679V3.344L5.325,2.036,6.894,3.786,8.276,5.156a.678.678,0,0,0,.479.2A.637.637,0,0,0,9.4,4.7.668.668,0,0,0,9.19,4.21L5.2.212a.7.7,0,0,0-1,0l-3.986,4A.668.668,0,0,0,0,4.7a.632.632,0,0,0,.642.66.681.681,0,0,0,.485-.2L2.5,3.786,4.077,2.03,4.023,3.344v7.482A.649.649,0,0,0,4.7,11.5Z'
        transform='translate(132.635 193.692) rotate(180)'
        fill='#808f94'
      />
    </g>
  </SvgIcon>
);

export default SortIcon;
